import { createFileRoute, Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/ui";
import { useApp } from "@/context/AppContext";
import { KundenStudio } from "@/pages/client/KundenStudio";

/**
 * EINE Adresse, zwei Sichten: Kunden (und die Kunden-Vorschau) sehen den
 * Teaser mit dem Interesse-Knopf. Das Team sieht seit dem Rundgang vom
 * 12.09.2026 eine ehrliche Bühne — die Studio-Demo aus dem Prototyp ist weg,
 * der Bereich kommt mit Etappe 8 echt. Kein Team-Menüpunkt bis dahin.
 */
export const Route = createFileRoute("/_angemeldet/studio")({
	component: StudioSeite,
});

function StudioSeite() {
	const { role } = useApp();
	if (role !== "mitarbeiter") return <KundenStudio />;
	return (
		<div className="card max-w-narrow">
			<EmptyState
				icon="film"
				title="Das Studio kommt mit Etappe 8"
				hint="Endcards, Reels aus Langvideos und Podcast-Schnitt entstehen hier, sobald die KI-Analyse des Materials gebaut ist. Bis dahin gibt es hier nichts zu klicken."
				action={
					<Link to="/projekte" search={{}} className="btn-secondary">
						Zu den Projekten
					</Link>
				}
			/>
		</div>
	);
}
